import { Searchbar } from 'react-native-paper';
import Color from 'color';
import styled from 'styled-components/native';

import Button from '@src/components/Button';
import { H2, Subtitle1 } from '@src/components/Typography';
import { maxHeight, padding, windowWidth } from '@src/configuration/constants';

import { FilterTermProps } from './types';

export const Container = styled.View`
  flex: 1;
  justify-content: flex-start;
  align-items: stretch;
  padding-left: ${padding}px;
  padding-right: ${padding}px;
`;

export const Row = styled.View`
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const Column = styled.View`
  width: 100%;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
`;

export const SliderContainer = styled.View`
  width: 90%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: center;
`;

export const Title = styled(H2)``;

export const PriceLabel = styled(Subtitle1)``;

export const SearchBar = styled(Searchbar).attrs(({ theme }) => ({
  icon: 'search',
  clearIcon: 'times',
  iconColor: Color(theme.colors.placeholder).lighten(0.25).hex(),
  placeholderTextColor: Color(theme.colors.placeholder).lighten(0.25).hex(),
}))`
  elevation: 0;
  min-width: ${windowWidth / 2}px;
  width: 100%;
  height: 80%;
  max-height: 50px;
  background-color: ${({ theme }) =>
    Color(theme.colors.background).darken(0.2).hex()};
`;

export const Spinner = styled.ActivityIndicator`
  margin: 10px auto;
  align-self: center;
`;

export const TermFilterContainer = styled.View`
  flex: 1;
  justify-content: space-evenly;
  align-items: stretch;
  max-height: ${maxHeight * 0.475}px;
`;

export const FilterTerm = styled(Button).attrs<FilterTermProps>(
  ({ active, theme }) => ({
    mode: active ? 'contained' : 'outlined',
    labelStyle: {
      color: active ? theme.colors.onPrimary : theme.colors.text,
    },
  })
)<FilterTermProps>`
  margin: 10px auto;
`;

export const Grid = styled.ScrollView.attrs({
  containerStyle: {
    width: '100%',
    justifyContent: 'space-evenly',
    alignItems: 'flex-start',
    flexWrap: 'wrap-reverse',
  },
})``;
